export default function validateInfo(values) {
  let errors = {};

  //check for duplicate email first
  if (values == "duplicate email") {
    errors.email = "Email address is already in use";
    return errors;
  }

  //check for empty username
  if (!values.username.trim()) {
    errors.username = 'Username required';
  }

  //check for invalid email format
  if (!values.email) {
    errors.email = 'Email required';
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Email address is invalid';
  }

  //check for empty password and password length
  if (!values.password) {
    errors.password = 'Password is required';
  } else if (values.password.length < 6) {
    errors.password = 'Password needs to be 6 characters or more';
  }

  //check for empty password2 and if passwords match
  if (!values.password2) {
    errors.password2 = 'Password is required';
  } else if (values.password2 !== values.password) {
    errors.password2 = 'Passwords do not match';
  }

  // check for empty account type
  if (!values.account) {
    errors.account = 'Required'
  } else if (values.account != 'Adopter' && values.account != 'Shelter') {
    errors.account = 'Required'
  }

  return errors;
}